import React from "react";

const SecuritySettings = ({ setPage }) => {
    return (
        <div className="settings-list">

            <div
                className="settings-item"
                onClick={() => setPage("change-password")}
                style={{ cursor: "pointer" }}
            >
                <p>Change Password</p>

                <span>
                    <i className="fas fa-chevron-right" />
                </span>
            </div>

        </div>
    );
};

export default SecuritySettings;